import { DriverBookingData, PreSignupBooking, State } from '../@types';

export const selectBookings = (store: State): Array<DriverBookingData> =>
  store.userData.bookings.bookings;
export const selectBookingViolations = (store: State) =>
  store.userData.bookings.bookingViolations;

export const selectPreSignupBooking = (store: State): PreSignupBooking =>
  store.userData.bookings.preSignupBooking;
